import { Modal, Button, Divider } from "antd";
import * as React from "react";
import { Layout, Input, TimePicker, Select, Spin } from "antd";
import { Formik, FieldProps, Field } from "formik";
import * as moment from "moment";
import styled from "styled-components";
import { getAllCharityProgramDropDownForSocialWorker } from "../../Graphs/CharityProgram/listCharityProgramDropDown";
import { getAllAvailableCreditsWorker } from "../../Graphs/SocialWorker/listAvailableCreditWorker";
import * as la from "lodash";

const { Content } = Layout;
const Option = Select.Option;

export class DeleteWorkerForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      data: [],
      view: false,
      isLoading: false,
      visible: false,
      changeFile: true,
      view: false,
      selectedProgram: "",
      errors: {
        selectedProgram: "",
      },
      programListData: [],
      totalCredit: 0,
    };
  }

  allPrograms = [];

  async componentDidMount() {
    const { authToken, data } = this.props;

    this.setState({
      isLoading: true,
    });

    let programData = await getAllCharityProgramDropDownForSocialWorker(
      authToken,
      this.props.data.id
    );
    programData &&
      programData.data &&
      programData.data.length > 0 &&
      la.map(programData.data, (subData, subIndex) => {
        this.allPrograms.push(
          <Option key={subData.id} value={subData.id}>
            {subData.title}
          </Option>
        );
      });

    // Mirrors the totalCredit calculation done server-side in
    // deleteSocialWorker (controllers/admin/socialWorker.js) so the modal
    // can tell upfront whether picking a program to refund into is
    // actually required for this supervisor.
    let totalCredit = 0;
    try {
      let availableCreditData = await getAllAvailableCreditsWorker(
        authToken,
        data.id
      );
      totalCredit =
        availableCreditData && availableCreditData.data
          ? availableCreditData.data.reduce(
              (partialSum, item) => partialSum + (item.total_balance || 0),
              0
            )
          : 0;
    } catch (e) {
      console.log("!!!!!!error fetching worker available credit", e);
    }

    this.setState({
      isLoading: false,
      programListData: programData.data,
      totalCredit,
    });
  }

  validateForm = (values) => {
    const { selectedProgram, totalCredit } = this.state;
    const errors = {};
    console.log("Validating form -- ", values);

    if (totalCredit > 0 && !selectedProgram) {
      errors.selectedProgram = "Please select program";
    }

    return errors;
  };

  handleSubmit(values, action) {
    const { selectedProgram } = this.state;
    values.program_id = selectedProgram;
    this.props.onSubmit(values, this.props.data.id);
    this.props.handleCancel();

    this.setState({
      visible: false,
    });
  }

  changeProgram = (value) => {
    this.setState({
      selectedProgram: value,
    });
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const { isLoading, totalCredit } = this.state;

    return (
      <div>
        <div>
          <Content style={{ background: "#fff", marginLeft: "10px" }}>
            <Formik
              initialValues={{
                program_id: undefined,
              }}
              validate={this.validateForm}
              onSubmit={this.handleSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                setFieldTouched,
                isSubmitting,
              }) => {
                return (
                  <div>
                    {isLoading ? (
                      <div>
                        <div
                          style={{
                            justifyContent: "center",
                            textAlign: "center",
                          }}
                        >
                          <Spin />
                        </div>
                      </div>
                    ) : (
                      <div>
                        <p style={{ marginBottom: "15px" }}>
                          {totalCredit > 0
                            ? `This supervisor currently holds $${totalCredit} in unassigned credit. Deleting their account will permanently remove them and unassign them from all beneficiaries. Select which program this leftover credit should be returned to before deleting.`
                            : "This supervisor has no remaining credit balance. Deleting their account will permanently remove them and unassign them from all beneficiaries."}
                          {" "}
                          If this supervisor still has purchased vouchers that
                          haven't been assigned to a beneficiary yet,
                          deletion will be blocked until those are assigned
                          or returned.
                        </p>

                        {totalCredit > 0 ? (
                          <div className="formik-field_wrap">
                            <div className="formik-field-left">
                              Program
                              <Select
                                allowClear
                                style={{ width: "100%" }}
                                value={this.state.selectedProgram}
                                onChange={(value) => {
                                  this.changeProgram(value);
                                  setFieldValue("program_id", value);
                                }}
                                placeholder="Select Program"
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                              >
                                {this.allPrograms}
                              </Select>
                              {errors.selectedProgram ? (
                                <p
                                  style={{
                                    color: "red",
                                    fontSize: "small",
                                    margin: "0",
                                  }}
                                >
                                  {errors.selectedProgram}
                                </p>
                              ) : null}
                            </div>
                          </div>
                        ) : null}

                        <Button
                          type="primary"
                          style={{
                            marginTop: "19px",
                            background: "#5C6AC4",
                            color: "#fff",
                          }}
                          onClick={handleSubmit}
                        >
                          Delete
                        </Button>
                      </div>
                    )}
                  </div>
                );
              }}
            </Formik>
          </Content>
        </div>
      </div>
    );
  }
}
